import { TableIconTextButton } from 'Components/Button';

const FileList = ({ title, files, removeAction }) => {
    //console.log(files);
    return (
        <div className="file-list-container">
            <div className="file-list-container-header">
                <p>{title}</p>
            </div>
            {
                files!=null && files.length !== 0
                    ? files.map((file, index) => (
                        <div key={index + file.name} className="file-list-row">
                            <div className="file-name"><p>{file.name}</p></div>
                            <TableIconTextButton className="w-auto" onClick={() => removeAction(file.name)} variant="table" content="Remove">
                            </TableIconTextButton>
                        </div>

                    ))
                    :
                    <div className="file-list-row">
                        <div className="file-no-selected"><p>No Files Selected</p></div>

                    </div>
            }
        </div>
    );
}

export default FileList; 